import RadioIcon from '@material-ui/icons/Radio'
import PlayerList from './PlayerList'
import PlayerEdit from './PlayerEdit'

export default {
  list: PlayerList,
  edit: PlayerEdit,
  icon: RadioIcon,
}
